import { DiscountSchema } from 'models/discount'
import { DiscountResponse } from 'models/http'
import { mockTenantsRef } from 'services/data-provider/mock'
import { mockMultiFamily1Chargers } from './charger-mock'

export const mockDiscountSchema = [
  {
    id: 516,
    name: 'Local Loitering Discount 4#4 11047f',
    promoCode: 'lpc_4#4_62cf08',
    tenantId: mockTenantsRef[3].id,
    usageStatus: 'active',
    discountPeriodWeekday: [...Array(48).fill(1)],
    discountPeriodWeekend: [...Array(48).fill(1)],
    discountPercentageWeekday: [...Array(48).fill(0)],
    discountPercentageWeekend: [...Array(48).fill(0)],
    loiteringSuspensionPeriodWeekday: [...Array(48).fill(0)],
    loiteringSuspensionPeriodWeekend: [...Array(48).fill(0)],
    ignoreChargingFee: false,
    ignoreLoiteringFee: true,
    ignoreConstantFee: false,
    ignoreDemandResponseFee: false,
    ignoreGuestFee: false,
    type: null,
    users: [
      {
        userId: '_YUm-toI6aswbqZ5-gp4Lg',
        userName: 'Sam Test',
        userEmail: 'samtest@gmail.com',
        timeAdded: '2024-06-19T16:39:19.450-04:00',
      },
      {
        userId: '7_SfFp5X0-kKx620vmnk5A',
        userName: 'Weihang Tang',
        userEmail: 'xwei@swtchenergy.com',
        timeAdded: '2024-06-19T16:39:19.655-04:00',
      },
      {
        userId: 'kBOh0wFTIyqz0xRfrklPKA',
        userName: 'Reesha mart',
        userEmail: 'reesha.martis+sw12@swtchenergy.com',
        timeAdded: '2024-06-19T16:39:19.826-04:00',
      },
      {
        userId: 'kVFx2WDhJd_PeRGHGc9JRg',
        userName: 'reeshamartisus8',
        userEmail: 'reesha.martis+us8@swtchenergy.com',
        timeAdded: '2024-06-19T16:39:19.854-04:00',
      },
      {
        userId: 'USXmgzwxwLShWu9bYMfMaw',
        userName: 'Weihang Tang',
        userEmail: null,
        timeAdded: '2024-06-19T16:39:19.887-04:00',
      },
      {
        userId: 'sE2u2PVq1n2bUuHx--6QfA',
        userName: 'reesha test1',
        userEmail: 'reeshaswtch+t1@gmail.com',
        timeAdded: '2024-06-19T16:39:19.923-04:00',
      },
    ],
    listingGroupId: 649,
    appliedListings: mockMultiFamily1Chargers.listings.slice(0, 3).map(({ id, title }) => ({
      listingId: id,
      listingTitle: title,
    })),
    creatorName: null,
    createdAt: '2024-06-19T16:39:19-04:00',
    updatedAt: '2024-06-28T10:51:16-04:00',
  },
  {
    id: 517,
    name: 'MVP',
    promoCode: 'MVP1234',
    tenantId: 1466,
    usageStatus: 'active',
    discountPeriodWeekday: [...Array(48).fill(0)],
    discountPeriodWeekend: [...Array(48).fill(0)],
    discountPercentageWeekday: [...Array(48).fill(100)],
    discountPercentageWeekend: [...Array(48).fill(100)],
    loiteringSuspensionPeriodWeekday: [...Array(48).fill(0)],
    loiteringSuspensionPeriodWeekend: [...Array(48).fill(0)],
    ignoreChargingFee: false,
    ignoreLoiteringFee: true,
    ignoreConstantFee: false,
    ignoreDemandResponseFee: false,
    ignoreGuestFee: false,
    type: null,
    users: [
      {
        userId: '_YUm-toI6aswbqZ5-gp4Lg',
        userName: 'Sam Test',
        userEmail: 'samtest@gmail.com',
        timeAdded: '2024-06-19T16:39:20.160-04:00',
      },
      {
        userId: '7_SfFp5X0-kKx620vmnk5A',
        userName: 'Weihang Tang',
        userEmail: 'xwei@swtchenergy.com',
        timeAdded: '2024-06-19T16:39:20.391-04:00',
      },
      {
        userId: 'kBOh0wFTIyqz0xRfrklPKA',
        userName: 'Reesha mart',
        userEmail: 'reesha.martis+sw12@swtchenergy.com',
        timeAdded: '2024-06-19T16:39:20.508-04:00',
      },
      {
        userId: 'kVFx2WDhJd_PeRGHGc9JRg',
        userName: 'reeshamartisus8',
        userEmail: 'reesha.martis+us8@swtchenergy.com',
        timeAdded: '2024-06-19T16:39:20.534-04:00',
      },
      {
        userId: 'USXmgzwxwLShWu9bYMfMaw',
        userName: 'Weihang Tang',
        userEmail: null,
        timeAdded: '2024-06-19T16:39:20.575-04:00',
      },
      {
        userId: 'sE2u2PVq1n2bUuHx--6QfA',
        userName: 'reesha test1',
        userEmail: 'reeshaswtch+t1@gmail.com',
        timeAdded: '2024-06-19T16:39:20.610-04:00',
      },
    ],
    listingGroupId: 550,
    appliedListings: mockMultiFamily1Chargers.listings.slice(3).map(({ id, title }) => ({
      listingId: id,
      listingTitle: title,
    })),
    creatorName: null,
    createdAt: '2024-06-19T16:39:19-04:00',
    updatedAt: '2024-06-19T16:39:19-04:00',
  },
] as DiscountSchema[]

export const mockDiscountSchemaResponse = {
  data: mockDiscountSchema,
  pagination: {
    currentPage: 1,
    totalEntries: mockDiscountSchema.length,
    perPage: 20,
  },
} as DiscountResponse
